import { type ExpertGridProps } from './ExpertGrid.props'

export const expertGridDefaults = {
  backgroundColor: '#f7f8fa',
  heading: 'Developed by Autumn Calabrese and her team of experts',
  subheading:
    'FPO Copy here about how amazing the team is behind it is. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  columnsDesktop: 4,
  columnsMobile: 2,
  experts: [
    {
      name: 'Nicole Reynolds',
      description: 'Professional Trainer',
      imageSrc:
        'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F72d60ecf53bb4303972b68711ea999a8',
      imageAlt: '',
    },
    {
      name: 'Dr. Melanie Marusso',
      description: 'Nutrition & Science Advisor',
      imageSrc:
        'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F72d60ecf53bb4303972b68711ea999a8',
      imageAlt: '',
    },
    {
      name: 'Marty Finkelstein, M.D.',
      description: 'Certified physician specializing in BHRT',
      imageSrc:
        'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F72d60ecf53bb4303972b68711ea999a8',
      imageAlt: '',
    },
    {
      name: 'Dr. Amanda Jones-Pritchett',
      description: 'Nurse practitioner',
      imageSrc:
        'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F72d60ecf53bb4303972b68711ea999a8',
      imageAlt: '',
    },
  ],
  imageSrcDesktop:
    'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F9c24e1711cb24b03b35212c9630abd53',
  imageSrcMobile:
    'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2Fe64af4885d724a0f8870eff8c8828f6a',
  imageAlt: '',
  imageRightDesktop: -120,
  imageScaleDesktop: 1.05,
  children: [
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      id: 'builder-7336f5391e8f4762adaf330777488555',
      component: {
        name: 'Text',
        options: {
          text: '<p><strong>Our team of experts</strong></p><p>BODi and Autumn have partnered with LaValle Performance Health team, which includes James LaValle and his team of MDs, Dietitians, and Doctor Nurse Practitioners (DNPs). James brings over 35 years of clinical experience to the Belle Vitale program and is taking the lead validating the program with a team of doctors and PhDs.</p>',
          style: 'Body Base',
        },
      },
    },
  ],
  childrenPositionDesktop: 'bottom',
} satisfies ExpertGridProps
